import React from 'react';

export default function Calendar({ 
    singleMonth = false, 
    bookedDates, 
    totalInventory, 
    startDate, 
    setStartDate, 
    endDate, 
    setEndDate, 
    currentMonth, 
    setCurrentMonth, 
    selectedOptionName, 
    vacationSettings 
}) {
    const isDateBooked = (dateString) => {
        const optionToCheck = selectedOptionName || 'default';
        const dailyBookings = bookedDates[dateString] || {};
        const bookedForOption = dailyBookings[optionToCheck] || 0;
        return bookedForOption >= totalInventory;
    };

    const handleDateClick = (date) => {
        const dateString = date.toISOString().split('T')[0];
        if (isDateBooked(dateString)) return;

        let isOnVacation = false;
        if (vacationSettings?.enabled && vacationSettings.startDate && vacationSettings.endDate) {
            if (dateString >= vacationSettings.startDate && dateString <= vacationSettings.endDate) {
                isOnVacation = true;
            }
        }
        if (isOnVacation) return; // Prevent clicking on vacation dates

        if (!startDate || (startDate && endDate)) {
            setStartDate(dateString);
            setEndDate(null);
        } else if (new Date(dateString) < new Date(startDate)) {
            setStartDate(dateString);
        } else {
            setEndDate(dateString);
        }
    };

    const renderCalendar = (monthDate) => {
        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const days = [];
        
        for (let i = 0; i < firstDay; i++) {
            days.push(<div key={`empty-${month}-${i}`} className="w-full h-10"></div>);
        }
        
        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(year, month, day);
            const dateString = date.toISOString().split('T')[0];
            const isBooked = isDateBooked(dateString);
            
            let isOnVacation = false;
            if (vacationSettings?.enabled && vacationSettings.startDate && vacationSettings.endDate) {
                if (dateString >= vacationSettings.startDate && dateString <= vacationSettings.endDate) {
                    isOnVacation = true;
                }
            }
            
            const isSelected = (startDate && dateString === startDate) || (endDate && dateString === endDate);
            const isInRange = startDate && endDate && dateString > startDate && dateString < endDate;
            const isPast = date < new Date(new Date().toDateString());

            let classes = "w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ";
            if (isPast || isBooked || isOnVacation) {
                classes += "text-gray-400 line-through cursor-not-allowed bg-gray-100";
            } else if (isSelected) {
                classes += "bg-pink-500 text-white";
            } else if (isInRange) {
                classes += "bg-pink-200";
            } else {
                classes += "hover:bg-pink-100";
            }
            
            days.push(
                <div 
                    key={`${month}-${day}`} 
                    onClick={() => !isPast && !isBooked && !isOnVacation && handleDateClick(date)} 
                    className={classes}
                >
                    {day}
                </div>
            );
        }
        return days;
    };

    const nextMonthDate = new Date(currentMonth);
    nextMonthDate.setMonth(currentMonth.getMonth() + 1);

    const handleNextMonth = () => {
        const newDate = new Date(currentMonth);
        newDate.setMonth(newDate.getMonth() + 1);
        setCurrentMonth(newDate);
    };

    const handlePrevMonth = () => {
        const newDate = new Date(currentMonth);
        newDate.setMonth(newDate.getMonth() - 1);
        setCurrentMonth(newDate);
    };

    return (
        <div className="w-full">
            <div className="flex justify-between items-center mb-4">
                <button onClick={handlePrevMonth} className="p-2 rounded-full hover:bg-gray-100 transition-colors">&lt;</button>
                <h3 className="font-bold text-gray-800">{currentMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}</h3>
                <button onClick={handleNextMonth} className="p-2 rounded-full hover:bg-gray-100 transition-colors">&gt;</button>
            </div>
            <div className="grid grid-cols-7 gap-1 mb-2">
                {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(d => (
                    <div key={d} className="text-center text-xs font-bold text-gray-400 uppercase tracking-wider">{d}</div>
                ))}
            </div>
            <div className="grid grid-cols-7 gap-1">
                {renderCalendar(currentMonth)}
            </div>
            {!singleMonth && (
                <div className="mt-6 border-t border-gray-100 pt-4">
                    <div className="flex justify-center items-center mb-4">
                        <h3 className="font-bold text-gray-800">{nextMonthDate.toLocaleString('default', { month: 'long', year: 'numeric' })}</h3>
                    </div>
                    <div className="grid grid-cols-7 gap-1 mb-2">
                        {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(d => (
                            <div key={d} className="text-center text-xs font-bold text-gray-400 uppercase tracking-wider">{d}</div>
                        ))}
                    </div>
                    <div className="grid grid-cols-7 gap-1">
                        {renderCalendar(nextMonthDate)}
                    </div>
                </div>
            )}
        </div>
    );
}